import { render, staticRenderFns } from "./EmployeesList.vue?vue&type=template&id=d045561a&scoped=true"
import script from "./EmployeesList.vue?vue&type=script&lang=js"
export * from "./EmployeesList.vue?vue&type=script&lang=js"
import style0 from "./EmployeesList.vue?vue&type=style&index=0&id=d045561a&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d045561a",
  null
  
)

export default component.exports